export default [
  {
    path: '/real-estate-developments/:id/stages/new',
    name: 'RealEstateDevelopmentsStagesCreate',
    component: () => import('pages/real-estate-developments/tabs/stages/StagesForm.vue')
  },
  {
    path: '/real-estate-developments/:parentId/stages/:id/edit',
    name: 'RealEstateDevelopmentsStagesEdit',
    component: () => import('pages/real-estate-developments/tabs/stages/StagesForm.vue')
  },
  {
    path: '/real-estate-developments/:parentId/stages/:id',
    name: 'RealEstateDevelopmentsStagesSingle',
    component: () => import('pages/real-estate-developments/tabs/stages/StagesSingle.vue')
  }
]
